angular.module('bookAndPay').directive('expireWarningMessage', function() {
  return {
    restrict: 'EA',
    scope: {
      cart: '='
    },
    template: require('templates/book_and_pay/expire_warning_message.html.slim'),
    controller: ["$scope", "$interval", "BookAndPayService", function($scope, $interval, BookAndPayService) {
      var calculateMinutesLeft, intervalId;
      calculateMinutesLeft = function() {
        var expiry, minutes, now;
        now = moment();
        expiry = moment($scope.cart.expires_at);
        minutes = expiry.diff(now, 'minutes');
        $scope.visible = minutes < 6;
        if (minutes < 1) {
          return 1;
        } else {
          return minutes;
        }
      };
      $scope.minutesLeft = calculateMinutesLeft();
      intervalId = $interval(function() {
        BookAndPayService.isExpired($scope.cart, true);
        return $scope.minutesLeft = calculateMinutesLeft();
      }, 1000);
      return $scope.$on('$destroy', function() {
        return $interval.cancel(intervalId);
      });
    }]
  };
});
